import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PanelEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const panelEntryPoint: EntryPoint<PanelEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<PanelEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/panel-system/dummy-entrypoint-component" */ './dummy-entrypoint-component',
		{
			moduleId: 'panel-entrypoint-1',
		},
	),
	getPreloadProps: () => ({}),
});
